<template>

  <div>

    <el-dropdown split-button type="default" @click="onClick" @command="onCommand">
      Edit form
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="list">View submissions</el-dropdown-item>
        <el-dropdown-item command="settings">Settings...</el-dropdown-item>
        <el-dropdown-item command="duplicate">Duplicate form...</el-dropdown-item>
        <el-dropdown-item command="delete" divided>Delete form</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

  </div>

</template>

<script>
  export default {
    props: ['form'],
    data() {
      return {
      }
    },
    methods: {
      onClick() {
        this.$router.push({ name: 'FormFieldsEdit', params: { id: this.form._id } })
      },
      async onDuplicate(item) {
        const { value } = await this.$prompt('Please input new title of form', 'Duplicate form', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          inputPattern: /[\w+]/,
          inputValue: item.title,
          inputErrorMessage: 'Invalid title'
        });

        try {
          const result = await this.$axios.post(`/v1/forms/${item._id}`, { title: value });

          this.$message.success('Form duplicated');
          await this.$store.dispatch('loadForms');
        } catch (err) {
          this.$message.error(err.toString());
        }
      },
      async deleteForm(form) {
        try {
          await this.$confirm('This will permanently delete the form. Continue?', 'Warning', {
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'warning'
          });
          this.loading = true;
          await this.$store.dispatch("deleteForm", form);
        } catch (err) {
        }
        this.loading = false;
      },
      onCommand(command) {
        switch (command) {
          case 'list': return this.$router.push({ name: 'FormSubmissions', params: { id: this.form._id }});
          case 'duplicate': return this.onDuplicate(this.form);
          case 'settings': return this.$emit('on-settings', this.form);
          case 'delete': return this.deleteForm(this.form);
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// Actions.vue?63dc97bb